<template>
  <b-card class="text-center p-4">
    <div class="d-flex flex-column align-items-center justify-content-center">
      <b-spinner variant="primary" label="Cargando..." class="mb-3" />
      <b-skeleton
          v-if="skeleton"
          animation="wave"
          width="80%"
          class="mb-2"
      />
      <b-skeleton
          v-if="skeleton"
          animation="wave"
          width="60%"
          class="mb-2"
      />
      <p class="mt-2 font-weight-bold">{{ message }}</p>
    </div>
  </b-card>
</template>

<script>
import { BCard, BSkeleton, BSpinner } from 'bootstrap-vue'

export default {
  name: 'FormLoader',
  props: {
    message: {
      type: String,
      default: 'Enviando formulario...'
    },
    skeleton: {
      type: Boolean,
      default: true
    }
  },
  components: {
    BCard,
    BSkeleton,
    BSpinner
  }
}
</script>
